import React from 'react'
import type { Podcast } from '../../../../types/podcast'

export const usePodcastLines = (podcast?: Podcast) => {
  // Sort podcast lines by sequence order; no versioning
  const currentLines = React.useMemo(() => {
    if (!podcast?.podcastLines) return []

    return [...podcast.podcastLines]
      .sort((a, b) => {
        // Sort by sequence order, fallback to id if sequence order is the same
        if (a.sequenceOrder !== b.sequenceOrder) {
          return a.sequenceOrder - b.sequenceOrder
        }
        return a.id.localeCompare(b.id)
      })
  }, [podcast?.podcastLines])

  return { currentLines }
}
